export default __webpack_public_path__ + "static/media/1 (5).0b1eda7a.jpg";